/**
 * Demo medical records for Doctor Assistant chatbot (replace with API later).
 */
export const DUMMY_VACCINATION_REPORT = {
  patient_name: "Adamya Sharma",
  patient_age: "26",
  patient_gender: "Male",
  doctor_name: "Dr. Bhargava",
  vaccines: [
    {
      vaccine_name: "HBS AG",
      dose_number: "II",
      date_administered: "12/02/2025",
      administered_by: "Dr. Bhargava",
    },
    {
      vaccine_name: "MMR",
      dose_number: "II",
      date_administered: "12/02/2025",
      administered_by: "Dr. Bhargava",
    },
    {
      vaccine_name: "CHICKENPOX",
      dose_number: "II",
      date_administered: "12/02/2025",
      administered_by: "Dr. Bhargava",
    },
    {
      vaccine_name: "COVID-19",
      dose_number: "II",
      date_administered: "12/02/2025",
      administered_by: "Dr. Bhargava",
    },
  ],
  other: {
    registration_no: "13256",
    fathers_name: "SK Sharma",
    place: "Chandigarh",
    document_date: "12/02/2025",
  },
  document_summary:
    "Adamya Sharma, a 26-year-old male, was seen by Dr. Bhargava in Chandigarh for the administration of several vaccinations. On February 12, 2025, the patient received the second dose of the HBS AG, MMR, Chickenpox, and COVID-19 vaccines. All four immunizations were administered by Dr. Bhargava during this visit. This record confirms the completion of these specific dose numbers within the patient's immunization schedule.",
  document_category: "Vaccination",
  document_subtype: "",
  gcs_path:
    "gs://mytara-medicaldocs/vaccinations/admin_at_tscti_com/20260319120348_984dfeeb_sample_vaccination.jpg",
  duplicate_upload: true,
  family_member: "self",
};

export const DUMMY_IMAGING_REPORT = {
  body_part: "Chest",
  document_summary:
    "A medical imaging report was performed focusing on the chest. This examination was conducted to evaluate the radiological status of this specific body part. No information regarding the patient's symptoms, identity, or the treating facility was provided in the extracted data. Furthermore, the specific findings and the radiologist's final impression are not available. As a result, no treatment plans or follow-up instructions can be summarized at this time.",
  document_category: "Imaging",
  document_subtype: "XRay",
  gcs_path:
    "gs://mytara-medicaldocs/imaging/adamyaS/xray/20260310104802_e144c9d9_sample_xray.jpg",
  duplicate_upload: true,
  family_member: "self",
};

export const DUMMY_PRESCRIPTION_REPORT = {
  patient_name: "Anne Burton",
  patient_age: "30",
  patient_gender: "Female",
  doctor_name: "Leslie Holden",
  medications: [
    {
      name: "Expectorant",
      is_supplement: false,
      salt_composition: "Guaifenesin",
      dosage: "1 tablet",
      side_effects: ["Nausea", "Vomiting", "Dizziness", "Headache"],
      age_based_dosage:
        "For a 30-year-old adult, the typical dosage of Guaifenesin is 200-400 mg orally every 4 hours as needed, not to exceed 2.4 g/day.",
      frequency: "Every 4 hours",
      instructions: "Oral",
      other: { purpose: "Removes phlegm" },
    },
    {
      name: "Paracetamol",
      is_supplement: false,
      salt_composition: "Paracetamol",
      allergies_related: ["Paracetamol allergy"],
      dosage: "1 tablet",
      side_effects: [
        "Nausea",
        "Stomach pain",
        "Loss of appetite",
        "Itching",
        "Rash",
      ],
      age_based_dosage:
        "For a 30-year-old adult, the typical dosage of Paracetamol is 500 mg to 1000 mg every 4 to 6 hours, with a maximum of 4000 mg per 24 hours.",
      frequency: "Every 4 hours",
      instructions: "Oral",
      other: { purpose: "For fever" },
    },
    {
      name: "Anti-biotic",
      is_supplement: false,
      salt_composition: "Amoxicillin",
      allergies_related: ["Penicillin allergy"],
      dosage: "500mg",
      side_effects: ["Diarrhea", "Nausea", "Vomiting", "Skin rash"],
      age_based_dosage:
        "For a 30-year-old adult, the typical dosage for Amoxicillin is 250 mg to 500 mg every 8 hours for mild to moderate infections.",
      frequency: "Every 8 hours",
      instructions: "Oral",
      other: { purpose: "Bacterial infection" },
    },
    {
      name: "Vitamin C",
      is_supplement: true,
      salt_composition: "Ascorbic Acid",
      dosage: "500mg",
      side_effects: ["Stomach cramps", "Nausea", "Heartburn", "Headache"],
      age_based_dosage:
        "For a 30-year-old adult, the recommended dietary allowance for Vitamin C is 75-90 mg daily, though supplemental doses of 500 mg are common and generally safe.",
      frequency: "Once a day",
      instructions: "Oral",
      other: { purpose: "Immune system" },
    },
    {
      name: "Vitamin D",
      is_supplement: true,
      salt_composition: "Cholecalciferol",
      dosage: "1 tablet",
      side_effects: ["Constipation", "Nausea", "Vomiting", "Poor appetite"],
      age_based_dosage:
        "For a 30-year-old adult, the recommended daily allowance for Vitamin D is 600-800 IU, though higher doses may be prescribed based on deficiency levels.",
      frequency: "Once a day",
      instructions: "Oral",
      other: { purpose: "Immune System" },
    },
  ],
  other: {
    prescription_no: "0001",
    prescription_date: "November 8, 2021",
    patient_dob: "Wednesday, November 8, 1989",
    patient_phone: "(123) 123-4567",
    patient_email: "anne.burton@noemailtest.com",
    patient_address: "1372 Payne Street, Richlands, VA, 24641",
    patient_allergies: "Seafood",
    notable_health_condition: "None",
    physician_phone: "(112) 312-3456",
    physician_email: "leslie.h@noemail.com",
    physician_signature_date: "November 9, 2021",
  },
  document_summary:
    "Anne Burton, a 30-year-old female, was treated by Dr. Leslie Holden on November 8, 2021. The prescribed treatment plan includes 500mg of Amoxicillin every eight hours for a bacterial infection, one tablet of Paracetamol every four hours for fever, and one tablet of an expectorant every four hours to assist with phlegm removal. Additionally, the patient was directed to take 500mg of Vitamin C and one tablet of Vitamin D daily to support her immune system. The medical record also notes that the patient has a known allergy to seafood.",
  document_category: "Prescription",
  document_subtype: "",
  gcs_path:
    "gs://mytara-medicaldocs/prescriptions/adamyaS/20260310104400_a71432d2_prescription_sample.jpg",
  duplicate_upload: true,
  family_member: "self",
};
